import { defineStore } from "pinia";
import { cleanWysiwygHtml } from "@/utils/utils";
import api from "@/api";
import TurndownService from "turndown";

const turndownService = new TurndownService();

export const useAnnouncementStore = defineStore("announcement", {
  state: () => ({
    messageSubject: "",
    message: "",
    batchId: null,
    users: [],
    usersFilters: {
      limit: 100,
      page: 1,
      name: "",
      email: "",
      status: "",
      roles: [],
      units: [],
      last_active_day: null,
    },
    selectedUsers: {},
    channelUsers: {},
    reviewUsers: {},
    confirmationUsers: {},
    intervalId: null,
    campaigns: [],
  }),
  getters: {
    selectedUsersArray() {
      return Object.values(this.selectedUsers);
    },
    channelUsersArray() {
      return Object.values(this.channelUsers);
    },
    reviewUsersArray() {
      return Object.values(this.reviewUsers);
    },
    confirmationUsersArray() {
      return Object.values(this.confirmationUsers);
    },
    markdownMessage() {
      return turndownService.turndown(this.message);
    },
  },
  actions: {
    // Add user
    addUser(user) {
      this.selectedUsers[user.id] = { ...user };
    },

    // remove user
    removeUser(userId) {
      delete this.selectedUsers[userId];
    },
    // Add channelUser
    addChannelUser(user) {
      // add extra properties
      const baseProps = {
        primary_channel: "",
        secondary_channel: "email",
      };

      this.channelUsers[user.id] = { ...user, ...baseProps };
    },
    // remove channelUser
    removeChannelUser(userId) {
      delete this.channelUsers[userId];
    },
    // Add reviewUser
    addReviewUser(user) {
      // add extra properties
      const baseProps = {
        primary_channel: "",
        secondary_channel: "",
      };

      this.reviewUsers[user.id] = { ...user, ...baseProps };
    },
    // remove reviewUser
    removeReviewUser(userId) {
      delete this.reviewUsers[userId];
    },
    // Add confirmationUsers
    addConfirmationUser(user) {
      // add extra properties
      const baseProps = {
        interaction_id: "",
        announcement_delivery_status: "PENDING",
      };

      this.confirmationUsers[user.id] = { ...baseProps, ...user };
    },
    // remove reviewUser
    removeConfirmationUser(userId) {
      delete this.confirmationUsers[userId];
    },
    // create campaign
    async createAnnouncementCampaign(logged_id, organization_id) {
      // Create body
      const body = {
        logged_id,
        organization_id,
        message_subject: this.messageSubject,
        message: cleanWysiwygHtml(this.message),
        selected_users: this.selectedUsers,
        channel_users: this.channelUsers,
        review_users: this.reviewUsers,
        confirmation_users: this.confirmationUsers,
      };

      // Make request
      const { data } = await api.broadcasts.createBroadcastCampaign(body);
      // For now console log, later add it to the store
      console.log("data: ", data);
      this.campaigns.push({ ...data.broadcast });
    },

    // fetch campaigns
    async fetchCampaigns(organization_id, limit = 10) {
      const body = {
        limit,
        organization_id,
      };

      // fetch
      const { data } = await api.broadcasts.fetchBroadcastCampaigns(body);
      console.log("data: ", data);

      // add to store
      this.campaigns = [...data.broadcasts];
    },
  },
});
